import BrandOrderPackingSlipPrototypePage from "@faire/prototype-playground/workspace/wh/brand-order-packing-slip";
import MazeTestPrototypePage from "@faire/prototype-playground/workspace/wh/maze-test";
import { Route, Switch } from "react-router-dom";

export function WyattHaymanRoutes() {
  return (
    <Switch>
      <Route
        path="/wh/brand-order-packing-slip"
        component={BrandOrderPackingSlipPrototypePage}
      />
      <Route path="/wh/maze-test" component={MazeTestPrototypePage} />
    </Switch>
  );
}

export const slug = "wh";
